import slice from "./webAnalyticsSlice";

export default slice.reducer;
